// extracted by mini-css-extract-plugin
module.exports = {"button":"StickyToggle_button__33f7b","wrapper":"StickyToggle_wrapper__4RsWh"};